<template>
    <div>
        <h4>Tony P. Huang ¹²³, Gregory A. Newby ¹²³, and David R. Liu ¹²³*</h4>
        <ol>
            <li>Merkin Institute of Transformative Technologies in Healthcare, The Broad Institute of MIT and Harvard, Cambridge, MA, USA</li>
            <li>Department of Chemistry and Chemical Biology, Harvard University, Cambridge, MA, USA</li>
            <li>Howard Hughes Medical Institute, Harvard University, Cambridge, MA, USA</li>
        </ol>
        <p style="font-size: 14px; margin-top: -20px">* Corresponding author</p>
    </div>
</template>

<script>
    export default {
        name: "Authors"
    }
</script>

<style scoped>
    p {
        color: black;
        padding: 10px
    }

    li {
      font-size: 14px  
    }
</style>